import React from "react";

export default function ProjetsSkeleton() {
  return (
    <div className="space-y-6">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6">
        <div className="h-6 w-56 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="h-24 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-900"
            />
          ))}
        </div>
      </div>

      <div className="h-[420px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />

      <div className="h-56 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />
    </div>
  );
}